hourly_
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import ContractNavigationWrapper from "@/components/ContractNavigationWrapper";
import ContractWorkerList from "@/components/ContractWorkerList";
import { formatPool, getBreakpoint } from "@/utils";
import DeleteContractModal from "@/pages/Contracts/Contract/DeleteModal";

export default {
  // Included components
  components: {
    ContractNavigationWrapper,
    ContractWorkerList,
    DeleteContractModal,
  },
  data() {
    return {
      // The ID of the worker being displayed
      contractId: null,
      contract: null,
      loading: true,
    };
  },

  computed: {
    // Mapped vuex state
    ...mapGetters(["can"]),
    ...mapState(["deviceTypes", "pools", "user"]),
  },

  // Initialize the state of the component
  async created() {
    if (!this.user.isStaffAdmin) {
      await this.$router.push("/");
    }

    this.contractId = this.$route.params.contractId;
    this.contract = await this.getContract({ contractId: this.contractId });
    this.loading = false;
  },

  methods: {
    // Helper methods and mapped vuex actions
    formatPool,
    getBreakpoint,
    ...mapActions([
      "getContract",
      "putContract",
      "postContract",
      "getDeviceTypes",
      "getPools",
    ]),
  },
};
</script>

<template>
  <ContractNavigationWrapper>
    <template #breadcrumbs>
      <b-breadcrumb-item to="/contracts">Contracts</b-breadcrumb-item>
      <b-breadcrumb-item active>
        {{
          contract != null
            ? contract.team.handle +
              "." +
              contract.facility.name +
              "." +
              contract.batch_number
            : "Contract"
        }}
      </b-breadcrumb-item>
    </template>
    <div v-if="!loading">
      <b-row class="mb-3">
        <b-col cols="7">
          <h1>
            {{
              contract.team.handle +
              "." +
              contract.facility.name +
              "." +
              contract.batch_number
            }}
          </h1>
        </b-col>
        <b-col v-if="!getBreakpoint().xs" cols="5" align-self="center">
          <div class="float-right">
            <span v-if="can.workers.edit">
              <b-button
                class="ml-3 mr-3"
                variant="danger"
                v-b-modal.delete-modal
              >
                Delete
              </b-button>
              <DeleteContractModal
                :contractId="contract.id"
                modal-id="delete-modal"
              />
              <b-button
                variant="primary"
                :to="'/contracts/' + contract.id + '/edit'"
              >
                Edit
              </b-button>
            </span>
          </div>
        </b-col>
        <b-col v-else cols="5" class="text-right">
          <b-dropdown class="mt-2" text="Actions" variant="primary" size="sm">
            <b-dropdown-item v-b-modal.delete-modal>Delete</b-dropdown-item>
            <DeleteContractModal
              :contractId="contract.id"
              modal-id="delete-modal"
            />
            <b-dropdown-item :to="'/contracts/' + contract.id + '/edit'">
              Edit
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card class="mb-3">
            <b-row>
              <b-col sm="6">
                <div>
                  <b>Team Name:</b>
                  {{ contract.team.handle }}
                </div>
                <div>
                  <b>Batch Number:</b>
                  {{ " " + contract.batch_number }}
                </div>
                <div>
                  <b>Machine Security Deposit:</b>
                  {{ " $" + contract.machine_security_deposit }}
                </div>
                <div>
                  <b>Machine Count:</b>
                  {{ " " + contract.machine_count }}
                </div>
                <div>
                  <b>Hourly Watt Consumption:</b>
                  {{ " " + contract.hourly_watt_consumption + " W" }}
                </div>
                <div>
                  <b>Customer Type:</b>
                  {{ " " + contract.customer_type }}
                </div>
                <div>
                  <b>Shipped Or Transferred:</b>
                  {{ " " + contract.shipped_or_transferred }}
                </div>
                <div>
                  <b>Device:</b>
                  {{ contract.device_type.name }}
                </div>
              </b-col>
              <b-col sm="6">
                <div>
                  <div>
                    <b>Start Date:</b>
                    {{ " " + contract.start_date }}
                  </div>
                  <b>Expiration Date:</b>
                  {{ " " + contract.expiration }}
                </div>
                <div>
                  <b>Facility Name:</b>
                  {{ " " + contract.facility.name }}
                </div>
                <div>
                  <b>Term Length:</b>
                  {{ " " + contract.term_length + " months" }}
                </div>
                <div>
                  <b>Machine Setup Fee:</b>
                  {{ " $" + contract.machine_setup_fee }}
                </div>
                <div>
                  <b>Rate Per kWh:</b>
                  {{ " $" + contract.rate_per_kWh }}
                </div>
                <div>
                  <b>Compatible:</b>
                  {{ " " + contract.compatible }}
                </div>
                <div>
                  <b>Invoiced via Stripe:</b>
                  {{ " " + contract.invoiced_in_stripe }}
                </div>
              </b-col>
            </b-row>
          </b-card>

          <b-card no-body class="mb-3">
            <b-card-body class="p-2 p-md-3">
              <ContractWorkerList
                :contract-id="contract.id"
                v-if="can.workers.view"
              />
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <b-row>
        <b-col class="text-center mt-5">
          <div class="mb-4">
            <b-spinner
              style="width: 4rem; height: 4rem"
              variant="primary"
              label="Loading Contract..."
            ></b-spinner>
          </div>
          <b>Loading Contract...</b>
        </b-col>
      </b-row>
    </div>
  </ContractNavigationWrapper>
</template>

<style scoped>
.Worker-stat-value {
  font-size: 1.4rem;
}

.Worker-device {
  color: #6c757d;
}
</style>
